import {
  actionsConfigOP,
  getEnumKeyByEnumValue,
  IActionObj,
} from "@/components/widgets/tradeActionSummary/helper/actionButtonsHelper";
import { notDealtStoreAction } from "@/store/tradeDataStoreACTIONS";
import { GetContextMenuItemsParams, MenuItemDef } from "ag-grid-community";

import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import showDesksStore from "@/store/showDesksStore";
import tradeDataStore from "@/store/tradeDataStore";
import tradesInProcessStore from "@/store/tradesInProcessStore";
import { Dispatch, SetStateAction } from "react";
import { IdefaultExpandedRowContext } from "../../ActionSummaryTableHelperFunctions";
import {
  returnAllocationsViewerArray,
  returnLegsViewerArray,
} from "../../helper/contextMenu/allocationsAndLegsViewerArrays";
import { isActionAllowedByFills } from "../../helper/fillStateHelpers";

export const hasRecoupon = (params: any): boolean => {
  let containsRecoupon = false;
  if (params.node.data.role == "OP") {
    params.node.data.executionRequestCounterParties[0].legs.forEach(
      (leg: any) => {
        if (leg.unwind == "Recoupon") {
          containsRecoupon = true;
        }
      },
    );
  } else if (params.node.data.role == "RP") {
    params.node.data.legs.forEach((leg: any) => {
      if (leg.unwind == "Recoupon") {
        containsRecoupon = true;
      }
    });
  }
  return containsRecoupon;
};

const GetExecutionContextMenuItems = (
  params: GetContextMenuItemsParams | any,
  additionalParams: {
    fullTradeData: any;
    getAccessTokenSilently: Function;
    expandedRowsContextCurrent: IdefaultExpandedRowContext[];
    setExpandedRowsContext: Dispatch<
      SetStateAction<IdefaultExpandedRowContext[]>
    >;
    setExpandedRowsContextMostRecentlyUpdated: Dispatch<SetStateAction<string>>;
    isERLevel: boolean;
    cryptoID: string | undefined;
  },
) => {
  const {
    fullTradeData,
    getAccessTokenSilently,
    expandedRowsContextCurrent,
    setExpandedRowsContext,
    setExpandedRowsContextMostRecentlyUpdated,
    cryptoID,
    // isERLevel,
  } = additionalParams;

  const expandedRowsContext = expandedRowsContextCurrent;

  // GO TO THE STORE AND GET THE UPDATED DATA. - Using 'fullTradeData' further in the prop passing was leading to stale values.
  const dataForMainTable = tradeDataStore.getState().tradeData;

  const fullTradeFromStore = dataForMainTable.find(
    (trade) => trade.esid == fullTradeData.esid,
  );

  // If no data in the store, no right hand clicks to be returned.
  //empty list will return a default browser right click which looks like a mistake
  if (!fullTradeFromStore) {
    return [];
  }

  const tradesInProcess = tradesInProcessStore.getState().tradesInProcess;
  if (fullTradeFromStore.role === "OP" && tradesInProcess.includes(fullTradeFromStore.esid)) return ["copy"];

  //Add the ESID to the params
  if (params && params.node && params.node.data) {
    params.node.data.esid = fullTradeFromStore.esid;
  }

  const getActions = (structureType: string, status: string) => {
    const keyToPass = getEnumKeyByEnumValue(
      // Reverse map the string back to the enum.
      ExecutionStrategyStatus, //Should this be ER?
      status,
    );
    if (keyToPass) {
      return actionsConfigOP[structureType]?.[keyToPass] || [];
    } else return [];
  };

  // 14868 - Revert code related to "/Trade/Execution/Recoupon" and ReCoupon flow.
  // const recouponActions = [
  //   returnRecouponArray({
  //     params,
  //     expandedRowsContext,
  //     setExpandedRowsContext,
  //     setExpandedRowsContextMostRecentlyUpdated,
  //     getAccessTokenSilently,
  //   }),
  // ];

  const defaultActions: (string | MenuItemDef)[] = ["copy", "copyWithHeaders"];

  const viewAllocationsAction = returnAllocationsViewerArray({
    params,
    expandedRowsContext,
    setExpandedRowsContext,
    setExpandedRowsContextMostRecentlyUpdated,
    getAccessTokenSilently,
  });

  const isRFQ = fullTradeFromStore.type;
  const getActionsType: "ER_RFQ" | "ER_Order" =
    isRFQ == "RFQ" ? "ER_RFQ" : "ER_Order";

  let actionButtonDefs = getActions(getActionsType, params.node?.data.status);
  if (fullTradeFromStore.status == ExecutionStrategyStatus.Awarded) {
    actionButtonDefs = actionButtonDefs.filter((item: IActionObj) => {
      if (item.id != "Award") {
        return item;
      }
    });
  }
  // Remove Cancel in OMS from the ER level - No need for it to appear here.
  if (fullTradeFromStore.status == ExecutionStrategyStatus.NotDealt) {
    actionButtonDefs = actionButtonDefs.filter((item: IActionObj) => {
      if (item.id != "Cancel in OMS") {
        return item;
      }
    });
  }
  // LQC-3248 / LQC-3250 - an Order with fills can't be Not Dealt or Recalled.
  actionButtonDefs = actionButtonDefs.filter((item: IActionObj) =>
    isActionAllowedByFills(item.id, fullTradeFromStore),
  );

  const actionMenuItemsER: (string | MenuItemDef)[] = actionButtonDefs.map(
    (returnedAction: IActionObj) => {
      return {
        name: returnedAction.id,
        action: () => {
          if (params.node) {
            const currentInProcess = tradesInProcessStore.getState().tradesInProcess;
            const esid = fullTradeFromStore!.esid;
            if (!currentInProcess.includes(esid)) {
              tradesInProcessStore.getState().addTradeInProcess([...currentInProcess, esid]);
            }
            returnedAction.function({
              data: fullTradeFromStore,
              getAccessTokenSilently: getAccessTokenSilently,
              executionRequestId: params.node.data.executionRequestId,
            });
          }
        },
        cssClasses: [
          returnedAction.id.toString().replace(/\s+/g, "") + "ActionButtonER",
        ],
        tooltip: params.node ? params.node.data.provider : "",
      };
    },
  );

  const viewLegsAction = returnLegsViewerArray({
    params,
    expandedRowsContext,
    setExpandedRowsContext,
    setExpandedRowsContextMostRecentlyUpdated,
    getAccessTokenSilently,
  });

  const notDealtItem = [
    {
      name: "Not Dealt",
      cssClasses: ["NotDealtActionButtonER"],
      icon: "", //close,
      action: () => {
        const currentInProcess = tradesInProcessStore.getState().tradesInProcess;
        const esid = fullTradeFromStore!.esid;
        if (!currentInProcess.includes(esid)) {
          tradesInProcessStore.getState().addTradeInProcess([...currentInProcess, esid]);
        }
        notDealtStoreAction({
          data: fullTradeFromStore,
          getAccessTokenSilently: getAccessTokenSilently,
        });
      },
    },
  ];

  const ERActionsList = [
    params.node?.data.provider
      ? {
          name: params.node?.data.provider + " ACTIONS",
          disabled: true,
        }
      : "",
    ...actionMenuItemsER,
    "separator",
  ];

  const selectDesks = [
    {
      name: "Select Desks",
      icon: "",
      action: () => {
        const objToPass = {
          widgetID: cryptoID,
          ESID: fullTradeData.esid,
        };
        const initialState = showDesksStore.getState().showingDesksList;
        let isShowingDesk = false;

        initialState.forEach((state) => {
          if (
            state.ESID == objToPass.ESID &&
            state.widgetID == objToPass.widgetID
          ) {
            isShowingDesk = true;
          }
        });

        if (!isShowingDesk) {
          const arrayToPass = [...initialState, objToPass];
          showDesksStore.getState().setShowingDeskList(arrayToPass);
        }
      },
    },
  ];

  if (fullTradeFromStore.role == "OP") {
    if (fullTradeFromStore.status == ExecutionStrategyStatus.New) {
      let showButton = false;
      let selectedRowContext = {
        esid: "",
        allocationsShowing: false,
        legsShowing: false,
      };
      expandedRowsContext.forEach((rowContext) => {
        if (rowContext.esid == fullTradeData.esid) {
          selectedRowContext = rowContext;
        }
      });

      if (
        selectedRowContext.esid != "" &&
        selectedRowContext.allocationsShowing == false &&
        selectedRowContext.legsShowing == false
      ) {
        showButton = true;
      }
      if (selectedRowContext.esid == "") {
        showButton = true;
      }
      if (showButton == false) {
        return [
          ...notDealtItem,
          "separator",
          viewAllocationsAction,
          viewLegsAction,
          "separator",
          ...defaultActions,
        ].filter(Boolean);
      } else {
        return [
          ...selectDesks,
          ...notDealtItem,
          "separator",
          viewAllocationsAction,
          viewLegsAction,
          "separator",
          ...defaultActions,
        ].filter(Boolean);
      }
    } else if (
      params.node.data.status == ExecutionStrategyStatus.Executed &&
      hasRecoupon(params)
    ) {
      return [
        // ...viewLegsActions,
        // 14868 - Revert code related to "/Trade/Execution/Recoupon" and ReCoupon flow.
        // ...recouponActions, // Shows legs for OR
        ...ERActionsList,
        viewAllocationsAction,
        viewLegsAction,
        "separator",
        ...defaultActions,
      ];
    } else if (expandedRowsContext.length > 0) {
      // expandedRowsContext[0].editPanelShowing == true
      let showButton = false;
      expandedRowsContext.forEach((rowContext) => {
        if (
          rowContext.esid == fullTradeData.esid &&
          rowContext.editPanelShowing == true
        ) {
          showButton = true;
        }
      });
      if (showButton) {
        return [
          ...selectDesks,
          ...ERActionsList,
          viewAllocationsAction,
          viewLegsAction,
          "separator",
          ...defaultActions,
        ];
      } else {
        return [
          ...ERActionsList,
          viewAllocationsAction,
          viewLegsAction,
          "separator",
          ...defaultActions,
        ];
      }
    } else {
      return [
        ...ERActionsList,
        viewAllocationsAction,
        viewLegsAction,
        "separator",
        ...defaultActions,
      ];
    }
  } else if (fullTradeFromStore.role == "RP") {
    return [viewAllocationsAction, "separator", ...defaultActions];
  } else {
    return [...defaultActions];
  }
};

export default GetExecutionContextMenuItems;
